import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";

const {removeClass, addClass, get, getAll} = $dom

const formGroupSelector = '.js-form-group'
const formCheckboxSelector = '.js-customer-data-checkbox'
const formDataSelector = '.js-customer-data-form'

const getterCheckboxSelector = '.js-getter-checkbox'
const getterButtonSelector = '.js-getter-button'
const getterSelector = '.js-getter-form'

export default function () {
    const handleCustomerData = (e) => {
        const form = getAll(formDataSelector)

        form.forEach(i => {
            $dom[e.target.checked ? 'removeClass' : 'addClass'](i, variables.classNames.hidden)
        })
    }

    const handleGetterInfo = (e) => {
        const form = getAll(getterSelector)

        form.forEach(i => {
            removeClass(i, variables.classNames.hidden)
            addClass(e.target.closest(getterCheckboxSelector), variables.classNames.hidden)
        })

    }

    const handleGetterClose = (e) => {
        const checkbox = getAll(getterCheckboxSelector)

        checkbox.forEach(i => {
            addClass(e.target.closest(getterSelector), variables.classNames.hidden)
            removeClass(i, variables.classNames.hidden)
            get('input', i).checked = false
        })
    }

    return new Component({
        name: 'form',
        requiredTargets: [
            formGroupSelector,
            formCheckboxSelector,
            formDataSelector,
            getterCheckboxSelector,
            getterButtonSelector,
            getterSelector
        ],
        onInit() {
            $events.delegate
                .on('change', formCheckboxSelector, handleCustomerData)
                .on('change', getterCheckboxSelector, handleGetterInfo)
                .on('click', getterButtonSelector, handleGetterClose)
        },
        onDestroy() {
            $events.delegate
                .off('change', formCheckboxSelector, handleCustomerData)
                .off('change', getterCheckboxSelector, handleGetterInfo)
                .off('click', getterButtonSelector, handleGetterClose)
        },
    })

}